import Styled from 'styled-components'


export const Menu = Styled.h1`
  font-weight: ${(props) => props.$fontWeight || 600};
  font-size: ${(props) => props.$fontSize || '18px'};
  line-height: 150%;
  text-align: center;
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
`